import styled from "styled-components";

export const Container = styled.div`
  background-color: ${({ theme }) => theme.colors['white']};
  height: 100vh;
  max-height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

export const TableWrapper = styled.div`
  padding: ${({ theme }) => `0px ${theme.dimensions.spacing[5]} ${theme.dimensions.spacing[4]} ${theme.dimensions.spacing[5]}`};
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
  max-height: calc(100vh - 150px);
`;